<bp-map [points]="mapMarkers" [pointsFilter]="pointsFilter" [visible]="mapVisible" [online]="false" [restrictedMode]="true" [(mapStatus)]="mapStatus"
[repositionMode]="canEdit"
(repositionConfirmed)="onPointChanged($event)"
[layers]="ls.mapDef().layers" (pointDeleted)="onPointDeleted()"></bp-map>
<div *ngIf="bp" class="coordinate-bar">
	<span class="coord-system">{{ bp.header.koordinaten.system || 'EPSG:5650' }}</span>
	<span class="coord-group">
		<span class="coord-label">X</span>
		<span class="coord-value">{{ bp.header.koordinaten.x }}</span>
	</span>
	<span class="coord-group">
		<span class="coord-label">Y</span>
		<span class="coord-value">{{ bp.header.koordinaten.y }}</span>
	</span>
</div>
